function initializeMifoaWooly(root = document) {
  root.querySelectorAll('[data-wooly-root]:not([data-wooly-ready])').forEach((module) => {
    module.dataset.woolyReady = 'true';

    module.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
      thumb.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        thumb.click();
      });
      thumb.addEventListener('click', () => {
        const gallery = thumb.closest('[data-wooly-gallery]');
        if (!gallery) return;
        const selected = thumb.dataset.galleryThumb;
        gallery.querySelectorAll('[data-gallery-thumb]').forEach((item) => {
          item.setAttribute('aria-pressed', String(item === thumb));
        });
        gallery.querySelectorAll('[data-gallery-main]').forEach((item) => {
          const active = item.dataset.galleryMain === selected;
          item.style.opacity = active ? '1' : '0';
          item.style.pointerEvents = active ? 'auto' : 'none';
        });
      });
    });

    const fit = module.querySelector('[data-wooly-fit-checker]');
    if (fit) {
      const verdict = fit.querySelector('[data-wooly-fit-verdict]');
      const copy = fit.querySelector('[data-wooly-fit-copy]');
      const setFit = (button) => {
        fit.querySelectorAll('[data-wooly-fit-tab]').forEach((tab) => {
          tab.setAttribute('aria-selected', String(tab === button));
          tab.setAttribute('tabindex', tab === button ? '0' : '-1');
        });
        if (verdict) verdict.textContent = button.dataset.verdict || '';
        if (copy) copy.textContent = button.dataset.copy || '';
      };
      fit.querySelectorAll('[data-wooly-fit-tab]').forEach((button) => {
        button.addEventListener('click', () => setFit(button));
        button.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const tabs = [...fit.querySelectorAll('[data-wooly-fit-tab]')];
          const next = event.key === 'ArrowRight' ? tabs[(tabs.indexOf(button) + 1) % tabs.length] : tabs[(tabs.indexOf(button) - 1 + tabs.length) % tabs.length];
          setFit(next);
          next.focus();
        });
      });
    }

    module.querySelectorAll('[data-wooly-load]').forEach((button) => {
      button.addEventListener('click', () => {
        const compare = module.querySelector('[data-xfade]');
        const before = compare?.querySelector('[data-xfade-before]');
        const beforeInner = compare?.querySelector('[data-xfade-beforeinner]');
        const handle = compare?.querySelector('[data-xfade-handle]');
        if (!compare || !before || !handle) return;
        const current = Number(handle.getAttribute('aria-valuenow')) || 50;
        const next = current > 50 ? 0 : 100;
        before.style.width = `${next}%`;
        handle.style.left = `${next}%`;
        handle.setAttribute('aria-valuenow', String(next));
        if (beforeInner) beforeInner.style.width = `${compare.getBoundingClientRect().width}px`;
        button.setAttribute('aria-pressed', String(next === 100));
        const label = button.querySelector('[data-wooly-load-label]');
        if (label) label.textContent = next === 100 ? button.dataset.unloadLabel || 'Show empty stand' : button.dataset.loadLabel || 'Load the wool';
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', () => initializeMifoaWooly(document), { once: true });
document.addEventListener('shopify:section:load', (event) => initializeMifoaWooly(event.target));
